import React from 'react';
import { Col } from '@appfolio/react-gears';
export var SentMessageContainer = function SentMessageContainer(_ref) {
  var receipt = _ref.receipt,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(Col, {
    tag: "li",
    sm: {
      size: 8,
      offset: 4
    },
    className: "pt-2 text-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mw-100 d-inline-block text-start rounded-3 w-auto py-2 px-3 mb-1 bg-primary text-white",
    ref: function ref(el) {
      if (el) {
        el.style.setProperty('border-bottom-right-radius', '0', 'important');
      }
    }
  }, children), receipt);
};
export var ReceivedMessageContainer = function ReceivedMessageContainer(_ref2) {
  var receipt = _ref2.receipt,
      children = _ref2.children;
  return /*#__PURE__*/React.createElement(Col, {
    tag: "li",
    sm: {
      size: 8,
      offset: 0
    },
    className: "pt-2 text-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mw-100 d-inline-block text-start rounded-3 w-auto py-2 px-3 mb-1 bg-secondary",
    ref: function ref(el) {
      if (el) {
        el.style.setProperty('border-bottom-left-radius', '0', 'important');
      }
    }
  }, children), receipt);
};